export const PAY_WAY = {
    "wx-h5":"微信H5", // 微信h5
    "wx-mini":"微信小程序", // 
    "wx-app":"App微信支付", // app
    "coupon":"优惠券", // 使用
    "integral":"积分支付", // 使用积分
    "balance":"余额" // 使用余额
};


// WEBPACK FOOTER //
// ./src/config/const.js